module.exports = __webpack_public_path__ + "static/img/top2.94c6d7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top2.png
// module id = 5TG9
// module chunks = 56